<div class="ml-translation-widget" *ngIf="shouldShowWidget" [class.minimized]="isMinimized">
  <!-- Minimized State: Just the icon -->
  <div class="widget-minimized" *ngIf="isMinimized" (click)="toggleMinimized()">
    <img
      src="assets/img/translate.png"
      alt=""
      class="translation-icon-img"
    />
  </div>

  <!-- Full Widget Content -->
  <div class="widget-content" *ngIf="!isMinimized">
    <!-- Close Button -->
    <button class="close-button" (click)="toggleMinimized()" type="button" title="Minimizar">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 1L1 13M1 1L13 13" stroke="#9333EA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <!-- Icon and Title -->
    <div class="widget-header">
      <div class="translation-icon">
        <img
          src="assets/img/translate.png"
          alt=""
          class="translation-icon-img"
        />
        <!-- <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.87 15.07L10.33 12.56L10.36 12.53C12.1 10.59 13.34 8.36 14.07 6H17V4H10V2H8V4H1V6H12.17C11.5 7.92 10.44 9.75 9 11.35C8.07 10.32 7.3 9.19 6.69 8H4.69C5.42 9.63 6.42 11.17 7.67 12.56L2.58 17.58L4 19L9 14L12.11 17.11L12.87 15.07ZM18.5 10H16.5L12 22H14L15.12 19H19.87L21 22H23L18.5 10ZM15.88 17L17.5 12.67L19.12 17H15.88Z"
            fill="#9333EA"
          />
        </svg> -->
      </div>
      <div class="row">
        <span class="widget-title">{{ 'translation:widget:title' | translate }}</span>
        <div class="toggle-section">
          <label class="switch">
            <input
              type="checkbox"
              [checked]="enabled"
              (change)="toggleEnabled()"
            />
            <span class="slider"></span>
          </label>
        </div>
      </div>
    </div>

    <!-- Toggle Switch -->

    <!-- Disclaimer Text -->
    <div class="disclaimer-text">
      <span>
        <img src="assets/img/megaphone.png" alt="" width="12" height="12" />
      </span>
      {{ 'translation:widget:disclaimer' | translate }}
    </div>

    <!-- Language Selector (only visible when enabled) -->
    <div class="language-selector" *ngIf="enabled">
      <label class="language-label">{{ 'translation:widget:language:label' | translate }}</label>
      <div class="dropdown-container">
        <button
          type="button"
          class="language-dropdown"
          (click)="toggleDropdown($event)"
          [class.open]="isDropdownOpen"
        >
          <span>{{ getSelectedLanguageName() }}</span>
          <svg
            width="12"
            height="8"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L6 6L11 1"
              stroke="#9CA3AF"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <div class="ml-dropdown-list" *ngIf="isDropdownOpen">
          <button
            type="button"
            *ngFor="let language of languages"
            class="ml-dropdown-option"
            [class.selected]="language.code === selectedLanguage"
            (click)="selectLanguage(language)"
          >
            {{ language.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
